import { tracked } from '@glimmer/tracking';
import { isDestroyed, isDestroying } from '@ember/destroyable';
import { action } from '@ember/object';
import { waitFor, waitForPromise } from '@ember/test-waiters';
import { modifier } from 'ember-modifier';
import { connectToChild } from 'penpal';
import { g, i, n } from 'decorator-transforms/runtime';

/**
 * We can't post right away, because we might do so before the iframe is ready.
 * We need to wait until the frame initiates contact.
 */
function PostMessage(handleUpdate) {
  return modifier((element, [data]) => {
    if (!element.contentWindow) return;
    if (data) {
      handleUpdate(data);
    }
  });
}
function HandleMessage(createConnection) {
  return modifier(element => createConnection(element));
}
class HostMessaging {
  static {
    g(this.prototype, "frameStatus", [tracked]);
  }
  #frameStatus = (i(this, "frameStatus"), void 0);
  /**
   * We can't post right away, because we might do so before the iframe is ready.
   * We need to wait until the frame initiates contact.
   */
  postMessage = PostMessage(data => void this.queuePayload('gjs', data));
  onMessage = HandleMessage(element => {
    this.connection = connectToChild({
      iframe: element,
      methods: {}
    });
    waitForPromise(this.connection.promise).catch(console.error);
    return () => void this.connection?.destroy();
  });
  async queuePayload(format, text) {
    await Promise.resolve();
    if (isDestroyed(this) || isDestroying(this)) return;
    if (!this.connection) return;
    const child = await this.connection.promise;
    if (isDestroyed(this) || isDestroying(this)) return;
    await child.update(format, text);
  }
  static {
    n(this.prototype, "queuePayload", [waitFor, action]);
  }
}

export { HostMessaging };
//# sourceMappingURL=frame-messaging.js.map
